import axios from 'axios';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Authenticationservice } from './../../services/authentication.service';
import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import Swal from 'sweetalert2';
//import { required } from '@rxweb/reactive-form-validators';
declare var $: any;

@Component({
  selector: 'app-askformoney6667',
  templateUrl: './askformoney6667.component.html',
  styleUrls: ['./askformoney6667.component.css']
})
export class Askformoney6667Component implements OnInit, OnDestroy, AfterViewInit {

  userdata: any;
  t0: any;
  usercode;
  askformoney: UntypedFormGroup;
  FormForwardFN: UntypedFormGroup;
  uploadPercentage$: Observable<number>;
  valuesTomodal = [];
  isLoading = false;

  e_comment1 = new UntypedFormControl(null, Validators.required);
  e_money_amt = new UntypedFormControl(null, Validators.required);
  e_docid = new UntypedFormControl(null, Validators.required);

  //@ViewChild('moneydata', { static: false }) moneydataTable: any;
  @ViewChild('moneydata') moneydataTable: ElementRef;
  constructor(
    private auth: Authenticationservice,
    private spinner: NgxSpinnerService,
    private storage: AngularFireStorage) {
    this.userdata = this.auth.Authention();
    this.usercode = this.userdata.supcode;
    this.askformoney = new UntypedFormGroup({
      comment: new UntypedFormControl(''),
      count: new UntypedFormControl(''),
      fmcode: new UntypedFormControl(''),
      t0: new UntypedFormControl(''),
      subtype: new UntypedFormControl(0),
      //  date_type0: new FormControl(''),   
    });
    // this.FormForwardFN = new FormGroup({ 
    // });

  }

  ngOnInit(): void {
    this.getfinancebyzone();
    this.goloadfarmerinzone();
    this.loadtype_money();
  }
  clearFm() {
    //this.fmcode = '';
    //this.oneplant = [];
    this.dataonefarmer = [];
    this.cleartext();
  }

  sum_money_amt = 0 //วงเงินที่ใช้ไป
  sum_money_amt1 = 0 //ขอเกี้ยว
  sum_money_amt2 = 0 //ขอเปิกปัจจัย

  RSUM_long = 0 //หนี้คงค้างของปี
  credit = 0 //มีวงเงิน
  limit = 0 //คงเหลือ

  ck_money_amt_last: any
  ck_sum_money_amt(fmcode: string) {
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/ck_sum_money_amt_w?yearID=6667&fmcode=' + fmcode
    axios.get(url)
      .then(res => {
        this.spinner.show();
        this.sum_money_amt = 0;
        this.sum_money_amt1 = 0;
        this.sum_money_amt2 = 0;
        if (res.data.rowsAffected >= 1) {
          let data_t = res.data.recordset;
          this.ck_money_amt_last = data_t;
          this.sum_money_amt1 = data_t[0].sum_money_amt1
          this.sum_money_amt2 = data_t[0].sum_money_amt2
          this.sum_money_amt = data_t[0].sum_money_amt
          setTimeout(() => {
            if (this.credit > 0 || this.RSUM_long > 0)
              this.limit = this.credit - (this.sum_money_amt + this.RSUM_long)
          }, 100);
        }
        //console.log('ck_money_amt_last',this.ck_money_amt_last)
        this.spinner.hide();
      }).catch(err => { console.log(err); })     //this.oneplant[0].canetype + ' พื้นที่ ' + this.oneplant[0].landvalue;
  }

  ck_realty_debt: any
  lodadck_realty_debt(fmcode: string) {
    this.spinner.show();
    axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/ck_realty_debt?year=6667&fmcode=" + fmcode)
      .then(res => {
        this.RSUM_long = 0;
        this.credit = 0;
        if (res.data.rowsAffected >= 1) {
          this.spinner.hide();
          let data = res.data.recordset;
          this.ck_realty_debt = data
          this.RSUM_long = data[0].RSUM_long_66
          this.credit = data[0].guaranter + data[0].sumRealty
          setTimeout(() => {
            if (this.credit > 0 || this.RSUM_long > 0)
              this.limit = this.credit - (this.sum_money_amt + this.RSUM_long)
          }, 100);
        }
        //console.log('ck_realty_debt',this.ck_realty_debt)

      }).catch(err => {
        console.log(err);
      })
  }

  datatype_m: any
  subtype0: any
  loadtype_money() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*,left([id],1)[l_id],RIGHT([id],1)[r_id]&f=[CPS6263].[dbo].[type_money]&w=1=1";
    axios.get(url)
      .then(res => {
        this.datatype_m = res.data;
        this.subtype0 = this.datatype_m.filter((el: any) => el.r_id == '0');
        //console.log('famerlist',this.famerlist)
      }).catch(err => { throw (err); })
  }
  // เลือกประเภทย่อย
  fsub = null
  sc_docA = null

  subtype1: any
  subtypeSL: string
  SubTypeSelectM(type0: string) {
    this.subtype1 = this.datatype_m.filter((el: any) => el.l_id == type0 && el.r_id != '0');
    //this.askformoney.get['subtype'].setValue(0);
    //this.askformoney.get("comment").value;
    this.fsub = null
  }
  SubTypeSelectS(sc_id: string, sc_doc: string) {
    this.sc_docA = sc_doc
    this.subtypeSL = sc_id
  }

  // โหลดข้อมูลชาวไร่ 
  famerlist: any;
  goloadfarmerinzone() {
    this.spinner.show();
    let url = "";
    // ผจก โซน
    if (this.userdata.userlevel == 14) {
      url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp6667?supzone=" + this.userdata.zonedata;
    }
    // ผจก ส่วน
    else if (this.userdata.userlevel == 15) {
      url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_fmcodeIn_cp6667?partcode=" + this.userdata.zonedata;
    }
    axios.get(url)
      .then(res => {
        this.famerlist = res.data.recordset;
        this.spinner.hide();
        //console.log('famerlist',this.famerlist)
      }).catch(err => { throw (err); })
    this.spinner.hide();
  }

  // ข้อมูลแปลงของชาวไร่ 1 คน
  dataonefarmer = [];
  canget: any;
  ckfarmer = false;
  @ViewChild('farmertable', { static: false }) farmerTable: any;


  can_withdraw = false
  goloaddata() {
    let fmcode = ((<HTMLInputElement>document.getElementById("codefm")).value).slice(0, 10)
    this.LoadCreditamt(fmcode);
    if (fmcode == '' || fmcode.length != 10) { alert('ลองกรอกรหัสชาวไร่ใหม่ หรือ คลิ๊กเลือก') }
    else {
      this.spinner.show();
      let sel_fm = this.famerlist.filter((el: any) => el.fmcode_b1 == fmcode);
      console.log('ckfamer', sel_fm.length, sel_fm);
      //console.log('ckfamer.length' ,ckfamer.length);

      console.log('fmcode', fmcode);
      if (sel_fm.length == 0) { alert('ชาวไร่ไม่ได้อยู่ในโซน/ส่วนที่รับผิดชอบ') }
      else if (sel_fm[0].PromiseIN == 0 || sel_fm[0].approve == 'N') {
        alert("ไม่สามารถเบิกได้ค่ะ");
        this.ckfarmer = true;
        this.can_withdraw = false;
        this.spinner.hide();
      }
      else if (sel_fm[0].zoneban == 'Y') {
        alert("ไม่สามารถทำรายการได้ เนื่องจากเป็นชาวไร่สำหรับฝ่ายกฎหมาย");
        this.ckfarmer = true;
        this.spinner.hide();
      }
      else {
        this.ckfarmer = false;
        this.spinner.hide();
      }
      let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp6667_basic_a]&w=fmcode='" + fmcode + "'";
      this.dataonefarmer = [];
      axios.get(url).then(res => {
        this.spinner.hide();
        if (res.data.length > 0) {
          this.dataonefarmer = (res.data).sort((a, b) => { return (a.intlandno) - (b.intlandno) });;
          //this.dataonefarmer
          /*setTimeout(() => {
            this.farmerTable.nativeElement.DataTable();
          }, 800);*/
          this.ck_sum_money_amt(fmcode);
          this.lodadck_realty_debt(fmcode);
        }
      }).catch(err => { throw (err); })

      /*
      let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/v_credit_limit_6667_w?fmcode_b1=%27" + fmcode + "%27";
      this.canget = null;
      axios.get(url2)
        .then(res => {
          this.canget = res.data.recordset;
          this.forwardcredit = this.canget[0].leftlimit;
          this.spinner.hide();
        }).catch(err => { console.log(err); })
        */
    }
  }

  crdamt = [];
  LoadCreditamt(fmcode: any) {
    this.spinner.show();
    let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[cps6263].[dbo].[v_sum_money_amt]&w=[YearID]='6667'and[fmcode]='" + fmcode + "'";
    this.canget = null;
    axios.get(url2).then(res => {
      this.spinner.hide();
      if (res.data.length > 0) {
        this.crdamt = res.data;
      }
      else {
        this.spinner.hide();
        this.crdamt = []
      }
    }).catch(err => { console.log(err); })
  }

  forwarditid: string;
  forwardfmcode: string;
  forwardintlandno: string;
  forwardcredit: any;
  checkcredit: any;
  sel_landno = [];
  snaponedata(itid: string) {
    let data = this.dataonefarmer.filter(el => el.itid == itid);
    this.forwarditid = data[0].itid;
    this.forwardintlandno = data[0].intlandno;
    this.sel_landno = data;
    let data2 = this.crdamt.filter(el => el.intlandno == data[0].intlandno);
    console.log('crdamt', this.crdamt)
    console.log('sel_landno', this.sel_landno)
    console.log('data2', data2)
    $("#plantnum").val(data[0].intlandno + ' ประเภทอ้อย ' + data[0].CaneTypeName + ' พื้นที่ ' + data[0].landvalue + ' ไร่');
    this.forwardfmcode = data[0].fmcode;
    if (data2.length == 0 || data2 == null) {
      this.checkcredit = [{ 'cdam': parseInt(data[0].credit_amount), 'sma': 0 }];
    }
    else {
      this.checkcredit = [{ 'cdam': parseInt(data[0].credit_amount), 'sma': parseInt(data2[0].sum_money_amt) }];
    }


    document.getElementById("fmnamelable").innerHTML = data[0].fmname;
    // $("#fmname").val(data[0].fmname);
  }

  // บันทึกข้อมูล
  gosave() {
    let fmcode = this.forwardfmcode;
    let cmdcheck = parseInt(this.checkcredit[0].cdam) - parseInt(this.checkcredit[0].sma);
    let itid = this.forwarditid;
    let intlandno = this.forwardintlandno;
    let comemnt = this.askformoney.get("comment").value;
    let conut = this.askformoney.get("count").value;
    let type_m = this.subtypeSL

    let over_limit = "0";
    let doc_status = "0";

    //console.log('fmcode',fmcode,'cmdcheck',cmdcheck,'conut',conut,'type_m',type_m,'substring type_m',type_m.substring(1,1),'conut',conut ,'cmdcheck',cmdcheck)
    //let type_money:string = null
    // กรณีเกินวงเงินแปลงนั้นๆ
    if (type_m.substring(0, 1) != 'a' && conut > cmdcheck) { over_limit = "1"; doc_status = "2" }

    // สำหรับการขอจาก ผจก.ที่เกินวงเงิน
    // if (conut > this.checkcredit.cdam) { over_limit = "1" }
    // { alert("จำนวนเงินเกินวงเงิน กรุณาลองใหม่");}
    //  if ( conut  > cmdcheck && this.userdata.userlevel != '15') {
    //     alert("จำนวนเงินเกินวงเงิน กรุณาลองใหม่");
    //   }

    console.log('conut :', conut, ' | cmdcheck:', cmdcheck)
    console.log('checkcredit', this.checkcredit)
    let textconfirm = 'ยืนยันการบันทึกข้อมูล';
    if (this.can_withdraw = false) { alert("ไม่สามารถบันทึกข้อมูลได้"); }
    else if (fmcode == null || fmcode == '') { alert("กรุณาระบุชาวไร่"); }
    else if (type_m == null || type_m == '') { alert("กรุณาเลือกประเภทเกี้ยว"); }
    else if (comemnt == null || comemnt == '') { alert("กรุณาระบุคำอธิบาย"); }
    else if (conut <= 0 || conut == null || conut == '') { alert("กรุณาระบุจำนวนเงินที่มากกว่า 0"); }
    else if (type_m.substring(0, 1) === 'a' && conut > cmdcheck) { alert("เงินส่งเสริมระยะสั้น ไม่สามารถเกินวงเงินรายแปลงได้"); }
    //else if (conut > this.limit ) { alert("ไม่สามารถบันทึกข้อมูลได้ เนื่องจากเบิกเกินหลักทรัพย์ค้ำประกัน"); }
    else {
      if (conut > this.limit) { textconfirm = "เนื่องจากยอดรวม " + conut + " เกินวงเงินคงเหลือ " + this.limit + " ต้องการการบันทึกข้อมูล" }
      if (confirm(textconfirm)) {
        let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_getfactorw?supcode='" + this.userdata.supcode + "'"
          + "&factor_type=" + '1' + "&itid='" + itid + "'" + "&intlandno='" + intlandno + "'"
          + "&fmcode='" + fmcode + "'" + "&YearID='6667'" + "&money_amt=" + conut + "&comment1='" + comemnt + "'"
          + "&img_url='" + this.geturlcontact + "'" + "&over_limit='" + over_limit + "'" + "&doc_status='" + doc_status + "'" + "&type_money='" + type_m + "'";
        axios.post(url).then(res => {
          if (res.data.rowsAffected[0] >= 1) {
            alert("บันทึกข้อมูลเรียบร้อยแล้วค่ะ");
            this.askformoney.reset();
            this.geturlcontact = '';
            this.LoadCreditamt(fmcode);
            this.ck_sum_money_amt(fmcode);
            setTimeout(() => {
              this.getfinancebyzone();
            }, 500);
          }
          else { alert("!!!! บันทึกข้อมูลไม่สำเร็จ !!!!"); }
        }).catch(err => { throw (err); })
      }
      else {
        {
          /*alert(" !! ยกเลิกบันทึกข้อมูลเรียบร้อยแล้วค่ะ !!");
          this.askformoney.reset();*/
        }
      }
    }
  }

  geturlcontact: any;
  // upload fire ภาพ
  onFileUpload(files: FileList): void {
    console.log(files);
    const file = files[0]; // get single file
    const path = `brr_smartfarm/contract/photo/${this.userdata.supcode}/6667/${file.name}`;
    const ref = this.storage.ref(path);
    const task = this.storage.upload(path, file);
    this.uploadPercentage$ = this.storage
      .upload(path, file)
      .percentageChanges();
    task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          ref
            .getDownloadURL()
            .toPromise()
            .then((url) => {
              // const photo: Photo = { url };
              // console.log(url);
              // this.urlimg = = url;

              // this.firestore.collection('photos').doc(this.truckq).set(photo);
            });
        })
      )
      .subscribe();

    let bucket = 'brr-farmluck.appspot.com'
    let url_pubilc = 'https://storage.googleapis.com/' + bucket + '/brr_smartfarm/contract/photo/' + this.userdata.supcode + '/6667/' + file.name;
    console.log(url_pubilc);
    this.geturlcontact = url_pubilc;
  }

  // clear ช่อง
  cleartext() {
    $("input").val('');
    //$("input:text").val('');
    //$("input:number").val('');
    this.geturlcontact = '';
    this.dataonefarmer = []
    this.sel_landno = [];
  }

  // โหลดข้อมูลสินเชื่อ
  datafinance = [];
  newtable: any
  getfinancebyzone() {
    if (this.newtable != undefined || this.newtable != null) {
      this.newtable.destroy();
    }
    this.isLoading = true;
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_getfinance6667]'
    let url2 = ''
    // console.log('userdata zonedata:' ,this.userdata.zonedata);
    if (this.userdata.userlevel == 15) {
      url2 = "&w=partcode=%27" + this.userdata.zonedata + "%27&over_limit=1"
    }
    else {
      url2 = "&w=zonePost=%27" + this.userdata.zonedata + "%27"
    }
    axios.get(url + url2).then(res => {
      this.spinner.hide();
      if (res.data.length > 0) {
        this.datafinance = [];
        let data = res.data;
        setTimeout(() => {
          this.datafinance = data;
          this.isLoading = false;
          setTimeout(() => {
            this.newtable = $(this.moneydataTable.nativeElement).DataTable({ order: [[0, 'desc']] });
          }, 300);
        }, 400);
      } else {
        this.spinner.hide();
        this.datafinance = [];
      }
    }).catch(err => { throw (err) });
  }

  ngOnDestroy() {
    this.forwarditid = null;
    this.forwardfmcode = null;
    this.forwardintlandno = null;
    this.forwardcredit = null;
    this.dataonefarmer = null;
    this.userdata = null;
    this.usercode = null;
    this.geturlcontact = null;
    this.datafinance = [];
  }

  // ส่งข้อมูลไปพิมพ์
  getfmcode(fmcode) {
    localStorage.setItem('fmcodedataforaskmoney', JSON.stringify(fmcode).toString());
  }

  // ต้องการยกเลิกรายการ
  cancledoc_id(data) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=" + data.firebaseid + "&doc_status=X";

    Swal.fire({
      title: 'ยืนยัน ยกเลิกเกี้ยว รายการนี้?',
      // text: 'You will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      console.log('cancledata url:', url);
      if (result.value) {
        axios.post(url).then(res => {
          if (res.data.rowsAffected == 1) {
            Swal.fire('ยกเลิกรายการเกี้ยวสำเร็จ!', '', 'success')
            //this.getfinancebyzone();
            this.datafinance.filter(el => el.firebaseid != data.firebaseid);
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'เกิดความผิดพลาดในการยกเลิกเกี้ยว!',
              footer: '<a href="">กรุณาลองใหม่อีกครั้ง หากยังพบปัญหา ให้ติดต่อ itBRD?</a>'
            })
          }
        })
      } else if (result.dismiss == Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการการทำรายการ',
          // 'Your imaginary file is safe :)',
          'cancle'
        )
      }
    })
  }

  // ส่งรายการให้ฝ่ายสินเชื่อ

  forwardtoFN(docid: string, money_amt: number, comment1: string, fmname: string, datepost: string) {
    $("#forwardtofn").modal('show');
    let values: (string | number)[] = [docid, money_amt, comment1, fmname, datepost];
    this.valuesTomodal = values;
    // console.log('value to modal is ',this.valuesTomodal);
  };

  // บันทึกข้อมูลของ หัวหน้าส่วน ไปยังฝ่ายสินเชื่อ
  saveforwardtoFN(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_getfactor?docid=" + f.e_docid
      + "&comment1=" + f.e_comment1 + "&money_amt=" + f.e_money_amt + "&doc_status=0";
    //console.log('url: ',url);
    Swal.fire({
      title: 'ยืนยันการบันทึกข้อมูล?',
      // text: 'You will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'OK ตกลง',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.value) {
        axios.post(url).then(res => {
          if (res.data.rowsAffected == 1) {
            Swal.fire('Saved!', '', 'success')
            this.getfinancebyzone();
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'เกิดความผิดพลาดในการอัพเดตข้อมูล!',
              footer: '<a href="">กรุณาลองใหม่อีกครั้ง หากยังพบปัญหา ให้ติดต่อ itBRD?</a>'
            })
          }
        })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'ยกเลิกการบันทึกข้อมูล',
          // 'Your imaginary file is safe :)',
          'cancle'
        )
      }
    })
  };

  // ส่งรายการให้ฝ่ายสินเชื่อ
  forwardtoFNX(doc_id) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_getfactor_2?firebaseid=" + doc_id + "&doc_status=0";
    if (confirm("ยืนยันส่งรายการไปยังฝ่ายสินเชื่อ ?")) {
      axios.post(url)
        .then(res => {
          if (res.data.rowsAffected[0] == 1) { alert("ส่งรายการไปยังฝ่ายสินเชื่อแล้ว"); this.getfinancebyzone(); }
          else {
            alert("!!! เกิดข้อผิดพลาดในการส่งรายการไปยังฝ่ายสินเชื่อ กรุณาลองใหม่ !!!")
          }
        }).catch(err => { throw (err); })
    } else {
      return false;
    }
  };

  ngAfterViewInit(): void {
    /*setTimeout(() => {
      $(this.moneydataTable.nativeElement).DataTable();
    }, 3500);*/
  }

  CommaFormatted(event) {
    // skip for arrow keys
    if (event.which >= 37 && event.which <= 40) return;
    // format number
    if (this.valuesTomodal) {
      this.valuesTomodal[1] = this.valuesTomodal[1].replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

  numberCheck(args) {
    if (args.key === 'e' || args.key === '+' || args.key === '-') {
      return false;
    } else {
      return true;
    }
  };
}